// TOPのKVエフェクト
window.addEventListener('load', function(event) {
    if (document.querySelector('.js-front')) {
        document.querySelector('.js-front').classList.add('is-loaded');
    }
})

// GSAPを使用したスクロール駆動エフェクト
import './_modules/scroll-trigger.js';

// Smooth scroll
import './_modules/smooth-scroll.js';

// particles
import './_modules/particles.js';